import { Autocomplete, Grid2, TextField, Typography } from "@mui/material";
import { RouterFormErrors, RouterPayload } from "../../types";

export interface RouterFieldConfig {
  field: keyof RouterPayload;
  label: string;
  placeholder: string;
  size: { xs: number; sm: number };
  select?: boolean;
}

export interface ConfigureRouterProps {
  form: RouterPayload;
  errors: RouterFormErrors;
  handleChange: (field: keyof RouterPayload, value: string) => void;
  fields: RouterFieldConfig[];
  ROUTER_MODES: string[];
  styles: any;
}
export default function ConfigureRouter(props: ConfigureRouterProps) {
  const { form, errors, handleChange, fields, ROUTER_MODES, styles } = props;
  return (
    <Grid2 container columnSpacing={1} sx={styles.boxFields}>
      {fields.map(({ field, label, placeholder, size, select }) => (
        <Grid2 size={size} key={field}>
          <Typography variant="subtitle2">{label}</Typography>
          {select ? (
            <Autocomplete
              fullWidth
              size="small"
              options={ROUTER_MODES}
              value={form[field] || null}
              onChange={(_event, newValue) =>
                handleChange(field, newValue ?? "")
              }
              isOptionEqualToValue={(option, value) => option === value}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder={placeholder}
                  error={Boolean(errors[field])}
                  helperText={errors[field] ?? " "}
                />
              )}
            />
          ) : (
            <TextField
              fullWidth
              size="small"
              autoComplete="off"
              placeholder={placeholder}
              value={form[field] ?? ""}
              onChange={(event) => handleChange(field, event.target.value)}
              error={Boolean(errors[field])}
              helperText={errors[field] ?? " "}
            />
          )}
        </Grid2>
      ))}
    </Grid2>
  );
}
